import { FunctionComponent } from 'react';

import { ModalRecentResultsConnected } from '../../../recentResults';

import styles from './leftDrawerCell.module.css';

export const LeftDrawerCellConnected: FunctionComponent = () => {
  return (
    <div className={styles.leftDrawerCell}>
      <ModalRecentResultsConnected />
    </div>
  );
};
